import {
  ImgCarouselAlfredoBonifaz,
  ImgCarouselAlfredoBonifaz2,
  ImgCarouselAlfredoBonifaz3,
  ImgCarouselAlfredoBonifaz4,
  ImgCarouselAlfredoBonifaz5,
  ImgCarouselCorazonJesus,
  ImgCarouselCorazonJesus2,
  ImgCarouselCorazonJesus5,
  ImgCarouselCorazonJesus6,
  ImgCarouselEmilioSoyer,
  ImgCarouselEmilioSoyer4,
  ImgCarouselEmilioSoyer5,
  ImgCarouselEmilioSoyer6,
  ImgCarouselEmilioSoyer7,
  ImgCarouselEmilioSoyer8,
  ImgCarouselEmilioSoyer9,
  ImgCarouselEsperanza3,
  ImgCarouselEsperanza4,
  ImgCarouselEsperanza5,
  ImgCarouselEsperanza6,
  ImgCarouselEsperanza7,
  ImgCarouselJesusNino,
  ImgCarouselJesusNino2,
  ImgCarouselJesusNino3,
  ImgCarouselJesusNino4,
  ImgCarouselJesusNino5,
  ImgCarouselJesusNino6,
  ImgCarouselJoseInclan2,
  ImgCarouselJoseInclan3,
  ImgCarouselJoseInclan4,
  ImgCarouselJoseInclan5,
  ImgCarouselJoseInclan6,
  ImgCarouselLasPalmas,
  ImgCarouselLasPalmas2,
  ImgCarouselLasPalmas3,
  ImgCarouselLasPalmas4,
  ImgCarouselLasPalmas5,
  ImgCarouselMatellini2,
  ImgCarouselMatellini3,
  ImgCarouselMatellini4,
  ImgCarouselMatellini5,
  ImgCarouselPedroRuizGallo,
  ImgCarouselPedroRuizGallo10,
  ImgCarouselPedroRuizGallo11,
  ImgCarouselPedroRuizGallo2,
  ImgCarouselPedroRuizGallo3,
  ImgCarouselPedroRuizGallo4,
  ImgCarouselPedroRuizGallo8,
  ImgCarouselPedroRuizGallo9,
  ImgCarouselPrimerosPasos,
  ImgCarouselPrimerosPasos2,
  ImgCarouselPrimerosPasos4,
  ImgCarouselPrimerosPasos5,
  ImgCarouselPrimerosPasos6,
  ImgCarouselPrimerosPasos7,
  ImgCarouselSantaIsabel,
  ImgCarouselSantaIsabel2,
  ImgCarouselSantaIsabel3,
  ImgCarouselSantaIsabel4,
  ImgCarouselSantaIsabel5,
  ImgJoseJoaquinInclan,
  ImgLasPalmas,
  ImgSantaIsabel,
  Inst1,
  Inst10,
  Inst11,
  Inst3,
  Inst4,
  Inst5,
  Inst6,
  Inst7,
  Inst9,
  LogoAlfredoBonifaz,
  LogoPrimerosPasos,
} from "../images";
import {
  faEnvelope,
  faGlobe,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";

export const limaInstitutes = [
  {
    image: Inst1,
    imgCarousels: [
      ImgCarouselPedroRuizGallo,
      ImgCarouselPedroRuizGallo2,
      ImgCarouselPedroRuizGallo3,
      ImgCarouselPedroRuizGallo4,
      ImgCarouselPedroRuizGallo8,
      ImgCarouselPedroRuizGallo9,
      ImgCarouselPedroRuizGallo10,
      ImgCarouselPedroRuizGallo11,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "PEDRO RUIZ GALLO",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    title4: "PAI y PD",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Av. Cdra 2 S/N Costado de la Clinica Maison de Sante Chorrillos, Chorrillos",
        url: "https://goo.gl/maps/j7kTFt1rHkt9GJSE8",
      },
      {
        icon: faFacebook,
        name: "facebook.com/IEPRG",
        url: "https://www.facebook.com/IEPRG",
      },
      {
        icon: faEnvelope,
        name: "informes@prg.edu.pe",
        url: "mailto:informes@prg.edu.pe",
      },
      {
        icon: faPhone,
        name: "01 6802674",
        url: "tel:016802674",
      },
      {
        icon: faGlobe,
        name: "prg.edu.pe",
        url: "https://prg.edu.pe/",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1ugr1y_i1NL2CcXi1FSThGSCJKxzNd6wq/view?usp=sharing",
  },
  {
    image: LogoAlfredoBonifaz,
    imgCarousels: [
      ImgCarouselAlfredoBonifaz,
      ImgCarouselAlfredoBonifaz3,
      ImgCarouselAlfredoBonifaz4,
      ImgCarouselAlfredoBonifaz5,
      ImgCarouselAlfredoBonifaz2,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "TC Alfredo Bonifaz",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Av. Morro de Arica 547 - Rimac",
        url: "https://www.google.com/search?q=Av.+Morro+de+Arica+547+-+Rimac&tbm=lcl&sxsrf=APq-WBu4MJch_t3FCMUss5lsZR1K-PJO3w%3A1646415357354&ei=_U0iYp76FOi55OUP9I-HwAM&oq=Av.+Morro+de+Arica+547+-+Rimac&gs_l=psy-ab.3...156870.156870.0.157531.1.1.0.0.0.0.113.113.0j1.1.0....0...1c.1.64.psy-ab..0.0.0....0.jSgCF_C5jcU#rlfi=hd:;si:7829503754212937258;mv:[[-12.02536381527003,-77.03745572656709],[-12.028333430156396,-77.04253046602327],null,[-12.026848626812058,-77.03999309629518],18]",
      },
      {
        icon: faFacebook,
        name: "facebook.com/TteCrlABonifaz",
        url: "https://www.facebook.com/TteCrlAlfredoBonifazFonseca",
      },
      {
        icon: faEnvelope,
        name: "img.istitucional@alfredobonifaz.edu.pe",
        url: "mailto:img.istitucional@alfredobonifaz.edu.pe",
      },
      {
        icon: faPhone,
        name: "915 390 214",
        url: "tel:+51915390214",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1zq2a1yFEn00-Nu8Pf_Ff-5tFzENblhc2/view?usp=sharing",
  },
  {
    image: Inst3,
    imgCarousels: [
      ImgCarouselEmilioSoyer,
      ImgCarouselEmilioSoyer4,
      ImgCarouselEmilioSoyer5,
      ImgCarouselEmilioSoyer6,
      ImgCarouselEmilioSoyer7,
      ImgCarouselEmilioSoyer8,
      ImgCarouselEmilioSoyer9,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "6005 GRAL EMILIO SOYER CABERO",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Av. Escuela 1151 - Chorrillosc",
        url: "https://www.google.com/search?q=Av.+Escuela+Militar+1151+-+Chorrillos&tbm=lcl&sxsrf=APq-WBsHcmx_u-ByH51jLMzKygaTNJTIHQ%3A1646415515772&ei=m04iYtrLLs_K5OUP4JyzwA4&oq=Av.+Escuela+Militar+1151+-+Chorrillos&gs_l=psy-ab.3..38.170160.170160.0.170877.1.1.0.0.0.0.251.251.2-1.1.0....0...1c.1.64.psy-ab..0.1.250....0.oorPqjI_JRg#rlfi=hd:;si:0x9105b7850e130035:0xf235631e1864ff63;mv:[[-12.16498072268097,-77.0194790883078],[-12.16534067731903,-77.01984731169217]]",
      },
      {
        icon: faFacebook,
        name: "facebook.com/iesoyer",
        url: "https://facebook.com/iesoyer",
      },
      {
        icon: faEnvelope,
        name: "soporte.ges@ie-esc.com",
        url: "mailto:soporte.ges@ie-esc.com",
      },
      {
        icon: faPhone,
        name: "(01) 2667321",
        url: "tel:+51012667321",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1yCWxSf1Mm0cx3WxMGvv44k0XvDaMmLyE/view?usp=sharing",
  },
  {
    image: Inst4,
    imgCarousels: [
      ImgJoseJoaquinInclan,
      ImgCarouselJoseInclan2,
      ImgCarouselJoseInclan3,
      ImgCarouselJoseInclan4,
      ImgCarouselJoseInclan5,
      ImgCarouselJoseInclan6,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "CRL JOSE JOAQUIN INCLAN",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Paseo De La Republica s/n, Chorrillos 15064",
        url: "https://www.google.com.pe/maps/place/I.E+Jose+Joaquin+Inclan/@-12.1778474,-77.0144271,13.56z/data=!4m5!3m4!1s0x9105b82a9d777277:0xc596e496acea88ca!8m2!3d-12.1721355!4d-77.0103712!5m1!1e4?hl=es-419",
      },
      {
        icon: faFacebook,
        name: "facebook.com/jjinclan",
        url: "https://www.facebook.com/jjinclan",
      },
      {
        icon: faPhone,
        name: "(01) 2515134",
        url: "tel:+51012515134",
      },
      {
        icon: faGlobe,
        name: "www.jjinclan.edu.pe/",
        url: "https://jjinclan.edu.pe/",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1gqElfhd2BDuA1M8BJkrIHcILox83ejUC/view?usp=sharing",
  },
  {
    image: Inst5,
    imgCarousels: [
      ImgCarouselJesusNino2,
      ImgCarouselJesusNino,
      ImgCarouselJesusNino3,
      ImgCarouselJesusNino4,
      ImgCarouselJesusNino5,
      ImgCarouselJesusNino6,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "JESÚS NIÑO",
    title3: "INICIAL - PRIMARIA - SECUNDARIA",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Avenida San Juan S / N, Block 4, Zone “B”, in the District of, San Juan de Miraflores",
        url: "https://www.google.com.pe/maps/place/IEPGP+Jes%C3%BAs+Ni%C3%B1o/@-12.1777312,-77.0144271,13z/data=!4m9!1m2!2m1!1sJESUS+NI%C3%91O!3m5!1s0x9105b851785760e5:0x151bbb753ef2bd31!8m2!3d-12.1551319!4d-76.9722636!15sCgtKRVNVUyBOScORT5IBBnNjaG9vbA!5m1!1e4?hl=es-419",
      },
      {
        icon: faFacebook,
        name: "facebook.com/IepgpJesusNino",
        url: "https://www.facebook.com/IEPGP.JESUS.NINO/",
      },
      {
        icon: faGlobe,
        name: "www.jnep.edu.pe",
        url: "https://jnep.edu.pe/",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1QeIh2f2br14_0-j7tvfJko-pFI7xlO-7/view?usp=sharing",
  },
  {
    image: Inst6,
    imgCarousels: [
      ImgCarouselEsperanza3,
      ImgCarouselEsperanza4,
      ImgCarouselEsperanza5,
      ImgCarouselEsperanza6,
      ImgCarouselEsperanza7,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "LA ESPERANZA",
    title3: "CUNA - JARDÍN",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Jr. Pantoja s/n Villa Militar Este - Chorillos",
        url: "https://goo.gl/maps/KrUNZ1RNEkAhVHbq7",
      },
      {
        icon: faFacebook,
        name: "facebook.com/007765308346",
        url: "https://goo.gl/maps/hvE3sEpZbNJvqPJP7",
      },
      {
        icon: faEnvelope,
        name: "iep.esperanza@gmail.com",
        url: "mailto:iep.esperanza@gmail.com",
      },
      {
        icon: faGlobe,
        name: "www.ielaesperanza.com",
        url: "https://www.ielaesperanza.com/",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1kuYJJHyPJ8Uk-wUKzErveV2l0QRIh5dT/view?usp=sharing",
  },
  {
    image: Inst7,
    imgCarousels: [
      ImgCarouselMatellini5,
      ImgCarouselMatellini2,
      ImgCarouselMatellini3,
      ImgCarouselMatellini4,
    ],
    title1: "IEPGP",
    title2: "MATELLINI",
    title3: "NIVEL INICIAL",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Prolongación Paseo de la República S/N, Villa Militar Matellini - Chorrillos",
        url: "https://www.google.com/search?q=Paseo+de+la+Republica+S%2FN+Villa+Militar+Matellini&tbm=lcl&sxsrf=APq-WBs4CjAD0N-rX4yIXLWlxutdjsFWow%3A1646415687635&ei=R08iYpmgJrin5OUPnsWx8As&oq=Paseo+de+la+Republica+S%2FN+Villa+Militar+Matellini&gs_l=psy-ab.3..33i160k1.149715.149715.0.150169.1.1.0.0.0.0.163.163.0j1.1.0....0...1c.1.64.psy-ab..0.1.162....0.HUNh9MauEMk#rlfi=hd:;si:9704235679558106126,l,CjFQYXNlbyBkZSBsYSBSZXB1YmxpY2EgUy9OIFZpbGxhIE1pbGl0YXIgTWF0ZWxsaW5pWjMiMXBhc2VvIGRlIGxhIHJlcHVibGljYSBzIG4gdmlsbGEgbWlsaXRhciBtYXRlbGxpbmmSARdlZHVjYXRpb25hbF9pbnN0aXR1dGlvbqoBIRABKh0iGXBhc2VvIGRlIGxhIHJlcHVibGljYSBzIG4oDg,y,CTlhycffxqU;mv:[[-12.173462929737067,-77.01034321466521],[-12.176430899388881,-77.01541795412139],null,[-12.174946918709246,-77.0128805843933],18]",
      },
      {
        icon: faFacebook,
        name: "facebook.com/IEPMatellini",
        url: "https://www.facebook.com/IEPMatellini",
      },
      {
        icon: faEnvelope,
        name: "Matricula.2020matellini@gmail.com",
        url: "mailto:Matricula.2020matellini@gmail.com",
      },
      {
        icon: faPhone,
        name: "986 856 383",
        url: "tel:+51986856383",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1zpGV4OnmszJrZEoKJffKKzYL88JOY8Ou/view?usp=sharing",
  },
  {
    image: LogoPrimerosPasos,
    imgCarousels: [
      ImgCarouselPrimerosPasos,
      ImgCarouselPrimerosPasos2,
      ImgCarouselPrimerosPasos4,
      ImgCarouselPrimerosPasos5,
      ImgCarouselPrimerosPasos6,
      ImgCarouselPrimerosPasos7,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "Primeros Pasos",
    title3: "CUNA - JARDÍN",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Av Paseo de la República 1341, Chorrillos 15064",
        url: "https://www.google.com.pe/maps/place/PRIMEROS+PASOS/@-12.1643437,-76.998963,13.26z/data=!4m9!1m2!2m1!1sPrimeros+Pasos!3m5!1s0x9105b77f97a4acb1:0xb715de9ff255eab4!8m2!3d-12.1761739!4d-77.0119991!15sCg5QcmltZXJvcyBQYXNvc5IBDXB1YmxpY19zY2hvb2w!5m1!1e4?hl=es-419",
      },
      {
        icon: faFacebook,
        name: "facebook.com/primerospasos.pasos",
        url: "https://www.facebook.com/ieprimerospasos",
      },
      {
        icon: faPhone,
        name: "(01) 2511047",
        url: "tel:+51012511047",
      },
      {
        icon: faGlobe,
        name: "https://primerospasos.sieweb.com.pe",
        url: "https://primerospasos.sieweb.com.pe/sistema/login",
      },
      {
        icon: faEnvelope,
        name: "ieprimerospasos@hotmail.com",
        url: "mailto:ieprimerospasos@hotmail.com",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1kQdHSgtuiYUEuhWcNdtDjC7jFt0sHrf1/view?usp=sharing",
  },
  {
    image: Inst9,
    imgCarousels: [
      ImgLasPalmas,
      ImgCarouselLasPalmas,
      ImgCarouselLasPalmas2,
      ImgCarouselLasPalmas3,
      ImgCarouselLasPalmas4,
      ImgCarouselLasPalmas5,
    ],
    title1: "Institución Educativa Pública de Gestión Privada",
    title2: "Las Palmas",
    title3: "CUNA - INICIAL",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Edmundo Aguilar S/N Villa Las Palmas",
        url: "https://www.google.com.pe/maps/place/Villa+Militar+%22Las+Palmas%22/@-12.1577059,-77.017386,1347m/data=!3m1!1e3!4m5!3m4!1s0x9105b82766625419:0x1baff5574f796e75!8m2!3d-12.156758!4d-77.013959!5m1!1e4?hl=es-419",
      },
      {
        icon: faFacebook,
        name: "facebook.com/laspalmas.ie.3",
        url: "https://www.facebook.com/ieejercitolaspalmas",
      },
      {
        icon: faEnvelope,
        name: "ieejercitolaspalmas@gmail.com",
        url: "mailto:ieejercitolaspalmas@gmail.com",
      },
      {
        icon: faPhone,
        name: "(01) 2521159",
        url: "tel:+51012521159",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1WxKrlnmztwr6EVsqu09rRbDDEuGboel4/view?usp=sharing",
  },
  {
    image: Inst10,
    imgCarousels: [
      ImgSantaIsabel,
      ImgCarouselSantaIsabel,
      ImgCarouselSantaIsabel2,
      ImgCarouselSantaIsabel3,
      ImgCarouselSantaIsabel4,
      ImgCarouselSantaIsabel5,
    ],
    title1: "Centro de Educación Básica Especial del Ejército del Perú",
    title2: "Santa Isabel",
    title3: "INICIAL - PRIMARIA Y PROGRAMA DE INCLUCIÓN FAMILIAR Y LABORAL",
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Villa  Este - Chorrillos",
        url: "https://www.google.com.pe/maps/place/CEBE+SANTA+ISABEL/@-12.1575438,-77.0179769,257m/data=!3m1!1e3!4m12!1m6!3m5!1s0x9105b78c6b7d1d05:0xd6846fd769c19645!2sVilla+Militar+Este!8m2!3d-12.1580414!4d-77.0143236!3m4!1s0x0:0xf1010f127d53eb5a!8m2!3d-12.1575967!4d-77.0177425!5m1!1e4?hl=es-419",
      },
      {
        icon: faFacebook,
        name: "m.facebook.com/cebesanta.isabel.3",
        url: "https://www.facebook.com/Centro-de-Educación-Básica-Especial-Santa-Isabel-100332839293866",
      },
      {
        icon: faPhone,
        name: "(01) 2666302",
        url: "tel:+51012666302",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1_JtO44J_yrkHdxKE7qsQwC66PYsGsdeU/view?usp=sharing",
  },
  {
    image: Inst11,
    title1: "Cuna",
    title2: "Corazon de Jesús",
    imgCarousels: [
      ImgCarouselCorazonJesus,
      ImgCarouselCorazonJesus2,
      ImgCarouselCorazonJesus5,
      ImgCarouselCorazonJesus6,
    ],
    socialLinks: [
      {
        icon: faLocationDot,
        name: "Av. Boulevard, Cuartel General San Borja",
        url: "https://www.google.com/maps/dir/-12.1858658,-77.0219014/-12.0986,-76.9937/@-12.0999888,-76.994594,16.56z/data=!4m4!4m3!1m1!4e1!1m0",
      },
      {
        icon: faFacebook,
        name: "facebook.com/cuna.corazondejesus",
        url: "https://www.facebook.com/Cuna-Coraz%C3%B3n-de-Jes%C3%BAs-106450965095491",
      },
    ],
    buttonUrl:
      "https://drive.google.com/file/d/1C4Ia4deKkwnt15VeS-ldZGX08Q39stM-/view?usp=sharing",
  },
];
